import React, { useEffect, useRef } from 'react';
import './Dashboard.css';
import { toTradingViewSymbol } from './tradingViewUtils';

const CHART_CONTAINER_ID = 'tradingview_chart_container';

/**
 * props:
 * - symbol
 */
function CandleChart(props) {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !window.TradingView) return;

    container.innerHTML = '';
    container.id = CHART_CONTAINER_ID;

    new window.TradingView.widget({
      symbol: toTradingViewSymbol(props.symbol),
      autosize: true,
      interval: '60',
      timezone: 'Etc/UTC',
      theme: 'light',
      style: '1',
      locale: 'en',
      toolbar_bg: '#f8fafc',
      enable_publishing: false,
      allow_symbol_change: false,
      details: true,
      withdateranges: true,
      hide_side_toolbar: false,
      studies: ['RSI@tv-basicstudies'],
      container_id: CHART_CONTAINER_ID,
    });

    return () => {
      container.innerHTML = '';
    };
  }, [props.symbol]);

  return (
    <div className="tradingview-chart-wrapper">
      <div ref={containerRef} className="divTradingView divTradingViewResponsive" />
    </div>
  );
}

export default CandleChart;